// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacySharedEmailAddressUpsearchModel {
    static getAttributeTypeMap() {
        return PharmacySharedEmailAddressUpsearchModel.attributeTypeMap;
    }
}
PharmacySharedEmailAddressUpsearchModel.discriminator = undefined;
PharmacySharedEmailAddressUpsearchModel.additionalProperties = false;
PharmacySharedEmailAddressUpsearchModel.attributeTypeMap = [
    {
        "name": "emailAddressId",
        "baseName": "emailAddressId",
        "type": "number"
    },
    {
        "name": "emailAddressType",
        "baseName": "emailAddressType",
        "type": "ContactInfoPurposeType"
    },
    {
        "name": "address",
        "baseName": "address",
        "type": "string"
    },
    {
        "name": "language",
        "baseName": "language",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacySharedEmailAddressUpsearchModel.js.map